import { render, staticRenderFns } from "./EmployeeViewSalaryModal.vue?vue&type=template&id=83fc4284"
import script from "./EmployeeViewSalaryModal.vue?vue&type=script&lang=js"
export * from "./EmployeeViewSalaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports